import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Paper,
    BottomNavigation,
    BottomNavigationAction,
    useTheme,
    alpha
} from '@mui/material';
import {
    Dashboard as DashboardIcon,
    Group as GroupIcon,
    Event as EventIcon,
    CalendarToday as CalendarIcon,
    Email as EmailIcon
} from '@mui/icons-material';

export default function BottomNav() {
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();

    // Determine active value based on path
    const getValue = () => {
        const path = location.pathname;
        if (path.startsWith('/dashboard')) return '/dashboard';
        if (path.startsWith('/groups')) return '/groups';
        if (path.startsWith('/parties')) return '/parties';
        if (path.startsWith('/calendar')) return '/calendar';
        if (path.startsWith('/invitations')) return '/invitations';
        return '/dashboard';
    };

    return (
        <Paper
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1200,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                backdropFilter: 'blur(20px)',
                borderTop: `1px solid ${alpha('#ffffff', 0.08)}`,
                borderRadius: '20px 20px 0 0',
            }}
            elevation={3}
        >
            <BottomNavigation
                showLabels
                value={getValue()}
                onChange={(event, newValue) => {
                    navigate(newValue);
                }}
                sx={{
                    backgroundColor: 'transparent',
                    height: 80, // Taller for better touch targets
                    '& .MuiBottomNavigationAction-root': {
                        color: 'text.secondary',
                        '&.Mui-selected': {
                            color: 'primary.main',
                        },
                    },
                }}
            >
                <BottomNavigationAction label="Home" value="/dashboard" icon={<DashboardIcon />} />
                <BottomNavigationAction label="Groups" value="/groups" icon={<GroupIcon />} />
                <BottomNavigationAction label="Parties" value="/parties" icon={<EventIcon />} />
                <BottomNavigationAction label="Calendar" value="/calendar" icon={<CalendarIcon />} />
                <BottomNavigationAction label="Invites" value="/invitations" icon={<EmailIcon />} />
            </BottomNavigation>
        </Paper>
    );
}
